module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAaBAMAAAC0pjrDAAAAG1BMVEUAAACSkZGRkZGPj4+Rj4+Pj4+RkZGRkZGSkZHmx8AsAAAACHRSTlMA74AwcBDv30UNC4sAAABzSURBVBjTXdAxCoAwDIXhIGQvdOnq5ijewKV4HMEL6JZjW8qv4uvQNvkKTWJWD3tW3c3jmomGOM1LZMKphbY1BiP1PYM9z0GakyyXF2EQXkA4QBiEQQ31MVhg+UjKkCJBktqgtg8yHAcZnZffYG39qhvTDQBvOiXLRlSWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wheel/vector.png
// module id = +GeV
// module chunks = 0